import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import Header from '../layout/header';
import Footer from '../layout/footer';


import bg from '../assets/img/bg-marine-4-1.jpg';
import bg2 from '../assets/img/bg-marine-1-2.jpg';
import bgm from '../assets/img/bgm-marine-4-1.jpg';
// import bgm3 from '../assets/img/bg-freight-m-3.png';
import logo from '../assets/img/logotssc2.svg';
import logo1 from '../assets/img/logo-marine-4.svg';

import img4 from '../assets/img/img-marine-4.jpg';
import imgm4 from '../assets/img/imgm-marine-4.jpg';

const Allrisksinsurance = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Header />
            <div className="wrapper bg-white ">
                <section className="box-index-res" >
                    <div className='logo-b-res  d-block d-md-none position-absolute' style={{ left: "20px", top: "20px",zIndex:"999999" }}>
                    <Link to="/home/myRef" transition='default-fade' className='btn-link-default border-0 pe-0'>
                        <img src={logo} alt="" className="" style={{ width: "100px" }} />
                    </Link>
                    </div>
                    <div className="container-fluid p-0">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="w-100 position-relative">
                                    <img src={bg} alt="" className="w-100 d-none d-md-block" />
                                    <img src={bgm} alt="" className="w-100 d-block d-md-none pt-5" />
                                    <div className='box-text-freight'>
                                        <h1 className='text-center text-md-start weight-700 mb-0'>OUR PRODUCTS</h1>
                                        <div className='color-green color-res-back text-center text-md-start'>ผลิตภัณฑ์</div>
                                    </div>
                                    <div className='box-text-freight-2' style={{ width:"42%" }}>
                                        <img src={logo1} alt="" className="w-75 px-4" />
                                        <div className='d-inline-block'>
                                            <h1 className='text-center text-md-center weight-400 mb-0 mt-1'>ALL  RISKS INSURANCE</h1>
                                            <h1 className='text-center text-md-center weight-700 mb-0'>FOR STOCK OR CONSTRUCTION</h1>                                            
                                            <hr className='hr-green' />
                                            <div className='mt-0 text-center'>กรมธรรม์ครอบคลุมความเสี่ยงสต็อคสินค้า หรือสิ่งก่อสร้าง</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className='box-bg-img-marine' style={{ backgroundImage: `url(${bg2})` }}>
                                    <div className='row align-items-center'>
                                        <div className="col-12 col-md-7 col-lg-7 bgm4marine">
                                            <img src={img4} alt="" className="w-100 d-none d-md-block" />
                                            <img src={imgm4} alt="" className="w-100 d-block d-md-none" />
                                        </div>
                                        <div className="col-12 col-md-5 col-lg-5">
                                            <div className='text-start p-5 p-md-5 textm4'>
                                                <h1 className='text-start text-md-start weight-400 mb-0 mt-1'>ALL  RISKS INSURANCE</h1>
                                                <h1 className='text-start text-md-start weight-700 mb-0'>FOR STOCK OR CONSTRUCTION</h1>
                                                <hr className='hr-green' style={{ width: "15%" }} />
                                                <div className='weight-400 mt-3'>
                                                บริษัท ไทยสตาร์ชัวร์ตี้ จำกัด<br />ดูแลกรมธรรม์ All Risks ครอบคลุมความเสี่ยง<br/>ของสต็อคสินค้า และสิ่งก่อสร้างให้กับ ZARA ทุกสาขา                                      
                                                </div>                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>
            </div>
            <Footer />

        </>
    );
};

export default Allrisksinsurance;